export const UNRECOGNIZED_RESPONSE_CODE = 'UNRECOGNIZED_RESPONSE_CODE';
export const FAILED_TO_PARSE_RESPONSE_BODY = 'FAILED_TO_PARSE_RESPONSE_BODY';
